import styles from './WeChatWallet.module.scss';
import cn from 'classnames';
import DelIcon from '@assets/icons/del.svg';
import WeChatIcon from '@assets/icons/we-chat-green-19.svg';
import { Fragment } from 'react';
import { IWeChatWalletProps, TWeChatWalletAction } from '../../types';
import { Text, TextColor, TextSize } from '@components/Text';

const WeChatWallet: React.FC<IWeChatWalletProps> = (props: IWeChatWalletProps): React.ReactElement => {
  const { actions, phone } = props;

  return (
      <div className={styles.wallet}>
        <div className={styles.info}>
          <img
              alt="WeChat"
              src={WeChatIcon}
          />
          <Text
              color={TextColor.PRIMARY}
              size={TextSize.S}
          >
            {phone}
          </Text>
        </div>
        {actions && (
            <div className={styles.actions}>
              {actions.map((action: TWeChatWalletAction, index: number) => (
                  <Fragment key={index}>
                    {action.type === 'delete' ? (
                        <button
                            className={styles.action}
                            onClick={action.self}
                        >
                          <img
                              alt="Delete"
                              src={DelIcon}
                          />
                        </button>
                    ) : (
                        <button
                            className={cn(styles.action)}
                            onClick={action.self}
                        >
                          {action.text}
                        </button>
                    )}
                  </Fragment>
              ))}
            </div>
        )}
      </div>
  );
};

export default WeChatWallet;